import { moxieMarketsAppBaseURL } from '@/utils/config.ts'

export function inviteWebUrl(invitationToken: string): string {
    return `${moxieMarketsAppBaseURL}/invite/${invitationToken}`
}
